import {
  ENTITLEMENT_DATA,
  GRID_ROWS_PER_PAGE,
  SWITCH_VALUE,
} from '../../../constants';

import { convertDateToISO } from '../../../utils/common';

export const initialState = {
  isEntitlementsLoading: false,
  selectededTab: 0,
  entitlmentDetailsSelectededTab: 0, //Details Tab Active State
  isMainScreen: false,
  isAddNew: false,
  loading: false,
  errors: {}, // You can store the form errors here
  isActiveLoading: false, // You can store the active loading here
  isDeactiveLoading: false, // You can store the deactive loading here
  isResultsFound: false, // variable for result found here
  isEntitlementsByIdResultsFound: false, // variable for result found here
  isEntitlementsSearchDataResultsFound: false, // variable for result found here
  isEntitlementsSiteHistoryByIdResultsFound: false, // variable for result found here
  isAccountingGroupsResultsFound: false, // variable for result found here
  isSitesResultsFound: false, // variable for result found here
  isServiceProductResultsFound: false, // variable for result found here
  gCNumberLoader: false, // variable for global customer number loader here
  errorModal: null, // variable for error modal here
  noDataFound: false, // variable for no data found here
  alertDialog: false, // variable for alert dialog here
  alertText: ENTITLEMENT_DATA.errorMsg, // variable for alert text here
  apiSuccessResponse: {
    activate: false,
    deactivate: false,
    create: false,
    update: false,
    get: '',
  }, // You can store the api success response here

  isentitlementsSearch: true, // You can store the current page as entitlements search page here
  isentitlementsMain: false, // You can store the current page as entitlements main page here
  isEntitlementsSearchDataGridVisible: false, // You can store the entitlements search data grid visible here

  //Entitlement Id Search and Data fetched by Id
  entitlementsQuickSearchId: '', // You can store Quick Search Id here
  tmpentitlementsQuickSearchId: '', // You can store Quick Search Id here

  //EntitlementsData
  tmpentitlementsSearchData: [], // You can store the entitlements search data here
  entitlementsSearchData: [], // You can store the entitlements search data here
  entitlementSearchDataGridTotalRecords: 0, // You can store the total records of the grid here

  //Entitlements Site History Data
  entitlementsSiteHistoryData: [], // You can store the entitlements site history data here
  entitlementsSiteHistoryTotalCount: 0, // You can store the entitlements site history total count here

  //Filters Dates Name
  entitlementsSearchFilterDatesName: {
    shipDate: 'Ship Date',
    importDate: 'Import Date',
    effectiveDate: 'Effective Date',
    endofServiceDate: 'End of Service Date',
    shipFromDate: 'shipFromDate',
    shipToDate: 'shipToDate',
    firstModifiedFromTimestamp: 'firstModifiedFromTimestamp', //to be replace by importFromDate
    firstModifiedToTimestamp: 'firstModifiedToTimestamp', //to be replaced by importToDate
    effectiveFromDate: 'effectiveFromDate',
    effectiveToDate: 'effectiveToDate',
    endofServiceFromDate: 'endofServiceFromDate',
    endofServiceToDate: 'endofServiceToDate',
  },

  entitlementsSearchOtherFiltersNumeric: {
    entitlementTypeId: 'entitlementTypeId', 
    entitlementStatusId: 'entitlementStatusId', 
    customerId: 'customerId', 
    vci: 'vci', 
    siteId: 'siteId', 
    vsi: 'vsi', 
    erpServiceProductId: 'erpServiceProductId', 
    oldRSIMProductId: 'oldRSIMProductId',
    warrantyPartNumber: 'warrantyPartNumber',     
    contractId: 'contractId', 
    contractHistoryTypeId: 'contractHistoryTypeId'
  },

  entitlementsSearchOtherFiltersNonNumeric: {
    serialNumber: 'serialNumber', 
    orderNumber: 'orderNumber',
  },

  //Search Filters Options
  entitlementsSearchOptions: {
    entitlementsSearchFilterDates: {
      shipFromDate: null,
      shipToDate: null,
      firstModifiedFromTimestamp: null, //to be replace by importFromDate
      firstModifiedToTimestamp: null, //to be replaced by importToDate
      effectiveFromDate: null,
      effectiveToDate: null,
      endofServiceFromDate: null,
      endofServiceToDate: null,
    },
    entitlementTypeId: 0,
    entitlementStatusId: 0,
    customerId: 0,
    vci: 0,
    siteName: '',
    siteId: 0,
    vsi: 0,
    erpServiceProductId: 0,
    erpServiceProductName: '',
    oldRSIMProductId: 0,
    warrantyPartNumber: '',
    serialNumber: '',
    orderNumber: '',
    contractId: '',
    contractHistoryTypeId: 0,
  },

  entitlementType: [],
  entitlementStatus: [],

  //Modals
  //Accounting Group Modal
  accountingGroupModal: {
    //Accounting Group
    openAccountingGroupModal: false, // You can store AccountingGrouo modal open status here
    accountingGroupSearchData: [], // You can store the AccountingGrouo search data here
    gridAccountingRowSelectedData: [], // You can store the grid row selected data here
    gridAccountingRowSelectedCount: 0, // You can store the grid rows selected count
    accountingGroups: [], // You can store the accounting groups here
    accountingGroupGridTotalRecords: 0, // You can store the total records of the grid here
    accountingGroupSearchForm: {
      accountingGroupCode: '',
      isActive: SWITCH_VALUE.blank,
      isResellerGroup: SWITCH_VALUE.blank,
    },
  },

  //Service Product Modal
  serviceProductModal: {
    // searchbox modal pop up product service name/code api states
    searchProductCodeNameLoading: false,
    searchProductCodeNameResult: [],
    searchProductCodeNameTotalRecords: 0,

    //dropdown servicelevel name api states
    fetchServiceLevelNameLoading: false,
    fetchServiceLevelNameResult: [],

    //delete orderable grid row api
    deleteOrderableLoading: false,
    deleteOrderableResult: [],

    //save  orderable grid data api
    saveOrderableLoading: false,
    saveOrderableResult: false,
    apiResponseStatus: '',

    //get orderable existing data
    fetchOrderableLoading: false,
    fetchOrderableResult: [],
    totalCount: 0,

    //modal open/close state
    openServiceProductModal: false,

    //modal open/close state supported
    openSupportedModal: false,

    //display name on input field states
    codeField: '',
    nameField: '',
    serviceProductField: '',
    serviceLevelId: 0,

    //object for grid & request modal
    orderableGridObject: [
      {
        contractId: 0, //will come from contract story
        erpServiceProductId: 0,
        serviceProductCode: '', //will come from productCode of erpServiceProductId
        serviceProductName: '', //will come from selected row of popupmodal
        servicePriceLevelId: 0,
        serviceOfferingName: '', //will come from selected droopdown of service level
        lastModifiedUserId: 0, //as of now constant 0
        lastModifiedTimestamp: convertDateToISO(),
      },
    ],
    //object for capturing selected row data from modalpopup
    serviceModalData: {
      id: 0,
      erpServiceProductId: 0,
      serviceProductCode: '',
      serviceProductName: '',
    },

    //object for capturing selected row data from service level dropdown
    serviceLevelDropdownData: {
      servicePriceLevelId: 0,
      serviceOfferingName: '',
    },

    gridData: [{}],
    isSet: false,

    //object for api call to save this should create from above object
    saveOrderableObject: [
      {
        contractId: 0, //will come from contract story
        erpServiceProductId: 0, //will come from selected row of popupmodal
        servicePriceLevelId: 0, //will come from selected droopdown of service level
        lastModifiedUserId: 0, //as of now constant 0
        lastModifiedTimestamp: convertDateToISO(), //current date
      },
    ],
    grandparentGridData: [],
  },

  //Customers Search Modal
  customersSearchModal: {
    inputError: null,
    searchResult: [],
    customersGridselectedRowData: [],
    customersGridResultsFound: false,
    customersGridTotalRecords: 0,
  },

  //Site Name Modal
  siteNameModal: {
    openSiteModal: false, // You can store Site modal open status here
    siteSearchData: [], // You can store the Sitesearch data here
    gridSiteRowSelectedData: [], // You can store the grid row selected data here
    gridSiteRowSelectedCount: 0, // You can store the grid rows selected count
    sites: [], // You can store the accounting groups here
    siteGridTotalRecords: 0, // You can store the total records of the grid here
    siteSearchForm: {
      name: '',
      siteId: '',
    },
  },

  //Filters - Global Customer Code Modal
  selectedComponent: ENTITLEMENT_DATA.radioButtonWithMultipleFilters, // variable for selected radio component
  globalCustomerNo: '',
  multipleInputsSelectedValues: {
    name: '',
    accountingGroup: '',
    accountingGroupName: '',
    parentPsCustomerCode: '',
    activeFlag: '',
    corporateCustomer: '',
    billtoCustomer: '',
    pageIndex: GRID_ROWS_PER_PAGE.initialVal,
    recordCount: GRID_ROWS_PER_PAGE.entitlementsGlobalCustomerNumberGrid,
  },
  dropDownValues: {
    activeFlag: ENTITLEMENT_DATA.dropDownDefaultValueForAny,
    corporateCustomer: ENTITLEMENT_DATA.dropDownDefaultValueForAny,
    billtoCustomer: ENTITLEMENT_DATA.dropDownDefaultValueForAny,
  },
  selectedCustomerNameInputValue: {
    name: '',
    accountingGroup: '',
    parentPsCustomerCode: '',
    activeFlag: '',
    corporateCustomer: '',
    billtoCustomer: '',
    pageIndex: GRID_ROWS_PER_PAGE.initialVal,
    recordCount: GRID_ROWS_PER_PAGE.entitlementsGlobalCustomerNumberGrid,
  },
  parentGlobalModal: {
    openParentGlobalCustomerNoModal: false, // You can store ParentGlobalCustomerNo modal open status here
    gridParentGlobalCustomerNoRowSelectedData: [], // You can store the grid row selected data here
    gridParentGlobalGridRowSelectedCount: 0,
    parentGlobalGridTotalRecords: 0,
    parentGlobalGridData: [],
    errorModal: null,
    customerNameSearchTerm: '',
    showCustomernameSelectedValue: null,
    name: [],
    isParentGlobalResultsFound: true,

    parentGlobalModalMultipleInputs: {
      name: '',
      accountingGroup: '',
      accountingGroupName: '',
      parentPsCustomerCode: '',
      activeFlag: '',
      corporateCustomer: '',
      billtoCustomer: '',
      pageIndex: GRID_ROWS_PER_PAGE.initialVal,
      recordCount: GRID_ROWS_PER_PAGE.entitlementsGlobalCustomerNumberGrid,
    },
    parentGlobalModalDropDownValues: {
      activeFlag: ENTITLEMENT_DATA.dropDownDefaultValueForAny,
      corporateCustomer: ENTITLEMENT_DATA.dropDownDefaultValueForAny,
      billtoCustomer: ENTITLEMENT_DATA.dropDownDefaultValueForAny,
    },
  },

  selectedGlobalCustomerRowData: [], // You can store the selected global customer row data here
  name: [],
  inputError: null,
  customerNameSearchTerm: '',
  showCustomernameSelectedValue: null,

  //Modals
  entitlementsSearchModal: {},
  user: '',

  //warrantyInfo Tab required data
  rqsIdfromEid:'None',
  warrantyIdfromEid:null,
  entitlementGridLoading: false,
};
